import React, { useState, useEffect } from 'react';
import {
  Button, Container, TextField, TableBody,
  IconButton, InputAdornment, CircularProgress, Tooltip, TableCell, Box, Typography, TableRow, TableHead, Paper, Table, TableContainer, Modal
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchIcon from "@mui/icons-material/Search";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useParams } from "react-router-dom";
import base64 from "base64-js";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const SubjectMaster = () => {
  const [isAuthorizing, setIsAuthorizing] = useState(true);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [canAdd, setCanAdd] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [subjectMaster, setSubjectMaster] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedsubmaster, setSelectedSubmaster] = useState(null);

  let navigate = useNavigate();
  const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") {
      console.error("encodedFormId is missing or invalid:", encodedFormId);
      return null;
    }
    try {
      const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(paddedEncodedFormId);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const { encodedFormId } = useParams();
  const formId = decodeFormId(encodedFormId);

  const Authorizer = async () => {
    try {
       setIsAuthorizing(true); 
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ formId, }), // replace with actual formId if hardcoded
      });

      const result = await response.json();
      const data = result[0];

      // setAuthorization(data);
      setCanEdit(data?.uModify === 1);
      setCanAdd(data?.uWrite === 1);
      setCanDelete(data?.uDelete === 1);
    } catch (error) {
      console.error("Authorization check failed:", error);
    }finally {
    setIsAuthorizing(false); // Stop loading
  }
  };

  const handleDelete = async (subjectID) => {
    try {
      setIsLoading(true); // Start loading
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/SubjectMaster/Id?Id=${subjectID}`;
      const token = sessionStorage.getItem('token');
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (response.ok) {
        setSubjectMaster(prevData => prevData.filter(item => item.subjectID !== subjectID));
        handleClose();
        setSnackbarMessage('Subject deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success");
      } else {
        console.error('Delete failed');
        // alert('Failed to delete subject master');
        setSnackbarMessage('Failed to delete subject master');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    } finally {
      setIsLoading(false); // Stop loading
    }
  };


  const fetchSubjectMaster = async () => {
    try {
      setIsLoading(true); // Start loading
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/SubjectMaster/GetSubject`;
      const token = sessionStorage.getItem('token');
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error(`Error fetching subject master data: ${response.status}`);
      }

      const subjectMasterData = await response.json();

      if (subjectMasterData.data === null && subjectMasterData.msg === "Record Not Found") {
        console.error('Record Not Found');
        // alert('Record Not Found');
        setSnackbarMessage('Record Not Found');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
        return;
      }

      setSubjectMaster(subjectMasterData);
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    } finally {
      setIsLoading(false); // Stop loading
    }
  };


  useEffect(() => {
    fetchSubjectMaster();
    Authorizer();
  }, []);

  const handleClose = () => {
    setShowModal(false);
    setSelectedSubmaster(null);
  };

  const handleClick = () => {
    navigate('/addsubjectmaster');
  };

  // Filter subjectMaster based on searchTerm
  const filteredSubjectMaster = subjectMaster.filter(submaster =>
    submaster.subjectName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset to page 1
  };

  const paginatedData = filteredSubjectMaster.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <>
   {isLoading || isAuthorizing ? (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50vh',
    }}
  >
    <CircularProgress />
  </Box>
)
 :(<Container>
      <Box
        sx={{
          backgroundColor: '#0B1F40', // dark navy blue
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0px auto',
          width: "100%"
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Subject Master</Typography> </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <TextField
            type="text"
            id="search"
            placeholder="Search"
            style={{ width: "300px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <Tooltip title={!canAdd && "You are not Authorized to Add"} arrow><span>

            <Button variant="contained" color="primary" style={{
              marginLeft: '10px', width: "160px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }} onClick={handleClick}
              disabled={!canAdd}>
              ADD
            </Button></span></Tooltip>
        </div>


        <TableContainer component={Paper}>
          <Table
            sx={{
              minWidth: 650,
              border: '1px solid #ccc',
              '& .MuiTableCell-root': {
                borderRight: '1px solid #ccc', // vertical line
                fontSize: '1rem', // increased font size
              },
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 'bold',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <TableHead>
              <TableRow >
                <TableCell><strong>Subject</strong></TableCell>
                <TableCell><strong>Short Name</strong></TableCell>
                {/* <TableCell><strong>Subject Type</strong></TableCell> */}
                {/* <TableCell><strong>Grade System</strong></TableCell> */}
                <TableCell><strong>Priority</strong></TableCell>
                <TableCell style={{ textAlign: 'center' }}><strong>Action</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((submaster) => (
                  <TableRow key={submaster.subjectID}>
                    <TableCell>{submaster.subjectName}</TableCell>
                    <TableCell>{submaster.shortName}</TableCell>
                    {/* <TableCell>{submaster.subjectType}</TableCell> */}
                    <TableCell>{submaster.priority}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>
                      <Tooltip title={!canEdit && "You are not Authorized to Edit"} arrow>
                        <span>
                          <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: '10px' }}
                            onClick={() => navigate(`/editsubmaster/${submaster.subjectID}`)}
                            disabled={!canEdit}
                          >
                            EDIT
                          </Button>
                        </span>
                      </Tooltip>
                      <Tooltip title={!canDelete && "You are not Authorized to Delete"} arrow>
                        <span>
                          <Button
                            className='mx-2'
                            variant="contained"
                            color="error"
                            onClick={() => {
                              setShowModal(true);
                              setSelectedSubmaster(submaster);
                            }}
                            disabled={!canDelete}
                          >
                            DELETE
                          </Button>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No Subject Details Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>
        </TableContainer>

        {filteredSubjectMaster.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
            <TextField
              select
              label="Rows per page"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              sx={{ width: 150 }}
              SelectProps={{
                native: true,
              }}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>

            <Box>
              <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                Page {page} of {Math.ceil(filteredSubjectMaster.length / rowsPerPage)}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page - 1)}
                disabled={page === 1}
                sx={{ mr: 1 }}
              >
                Prev
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page + 1)}
                disabled={page >= Math.ceil(filteredSubjectMaster.length / rowsPerPage)}
              >
                Next
              </Button>
            </Box>
          </Box>
        )}

      </Paper>
      {/* Delete Confirmation Modal */}
      <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete <strong>{selectedsubmaster?.subjectName}</strong>?
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleDelete(selectedsubmaster.subjectID)}
              >
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>


   </Container>)}
  </>
);}
export default SubjectMaster;
